"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var init_1 = require("./common/init");
Object.defineProperty(exports, "beforeInit", { enumerable: true, get: function () { return init_1.beforeInit; } });
Object.defineProperty(exports, "assign", { enumerable: true, get: function () { return init_1.assign; } });
Object.defineProperty(exports, "shallowClone", { enumerable: true, get: function () { return init_1.shallowClone; } });



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/interface-region/node_modules/@uip-alpha/interface-utils/dist/index.js
// module id = cA2x
// module chunks = 1